import script from "./MessagePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./MessagePopup.vue?vue&type=script&setup=true&lang=js"

import "@/features/message/styles/MessagePopup.css?vue&type=style&index=0&id=7254fb05&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7254fb05"]])

export default __exports__